import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import PastorForm from '@/components/forms/PastorForm';
import FormWrapper from '@/components/forms/FormWrapper';
import { PastorData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdatePastor = () => {
  const { pastorDataJson, pastorIndex } = useLocalSearchParams<{
    pastorDataJson: string;
    pastorIndex: string;
  }>();
  const [initialPastorData, setInitialPastorData] = useState<PastorData | undefined>(undefined);

  useEffect(() => {
    if (pastorDataJson) {
      const parsedPastor = safeJsonParse<PastorData>(pastorDataJson);
      if (parsedPastor) setInitialPastorData(parsedPastor);
    }
  }, [pastorDataJson]);

  return (
    <SafeAreaView style={styles.content} edges={['bottom']}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <PastorForm
            initialData={initialPastorData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/edit/npoPastors',
                params: {
                  pastorDataJson: JSON.stringify(data),
                  pastorIndex: pastorIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },
  container: {
    flex: 1
  }
});

export default AddUpdatePastor;
